import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useState,useEffect } from "react";
import sadminapi from '../api/sadminapi';
import loginapi from '../api/login';
import { AiOutlineDownload } from "react-icons/ai";
import { APISERVERURL } from '../APIServerURL';
import User from '../components/UserCard';

function ManageUser({accessToken,setAccessToken,setRefreshFailed  }) {
  const navigate = useNavigate();
    const [users,setUsers]=useState([]);
    const [isLoading,setIsLoading]=useState(false);
       
  const handleGoBack = () => {
    navigate(`/`); 
  };

    async function loadUsers()
        {
           setUsers([]);
           setIsLoading(true);
          try{
            const response= await sadminapi.post('/getUsers',{},{headers:{'Authorization':`Bearer ${accessToken}`}});    
              setUsers(response.data.users);
          }
          catch(err)
          {
            if( err.response.status===403)
              {
                navigate(`/accessdenied`); 
              }
            try{
              const config = { withCredentials: true };
              const x=await loginapi.get('/getAccessToken',config);
              
              const nat=x['data']['accessToken'];
              setAccessToken(nat);
              try{       
               const response= await sadminapi.post('/getUsers',{},{headers:{'Authorization':`Bearer ${nat}`}});    
              setUsers(response.data.users);
               }
               catch(err)
               {
                if( err.response.status===403)
                  {
                    navigate(`/accessdenied`); 
                  }
                alert('unusual error newposts.js');
               }
            }
            catch(err)
            {
              alert('failed');
            }
    
          }
          finally
          {
            setIsLoading(false);
          }
      }

    useEffect(()=>{
    
    loadUsers();
  },[]);        
  return (
     <main className="w-full">
       <div className="w-full bg-red-100 relative py-1">
            {/* Absolute Positioned Button */}
            <button  onClick={handleGoBack}  className="absolute top-1.5 left-1.5 bg-red-500 text-white px-4 py-2 rounded-lg shadow-md hover:bg-red-600 transition duration-300 text-xs">
              BACK
            </button>

            {/* Heading */}
            <h1 className="text-2xl  text-gray-400 text-center">MANAGE USERS</h1>
            <p className="w-full text-center font-semibold text-xs text-transparent">(The form is autosave)</p>    
          </div>

      <div className="flex flex-col items-center justify-center w-full p-1">
        <div className="w-full flex flex-col items-center justify-center">
          <p className="text-center w-full text-3xl">{users.length} users</p>
          <Link
  to="/addNewUser"
  className="mt-2 mb-3 text-sm px-4 py-2 bg-blue-200 hover:bg-blue-600 text-gray-800 hover:text-white rounded-md inline-block text-center"
>
  ADD NEW USER
</Link>

        </div>
        <div className="flex flex-wrap justify-center items-start gap-4 w-full min-h-[500px] p-2 mt-4">
{users.map(user => (
  <User key={user.user_name} user={user} />
))}</div>
      </div>
          
     </main>
  );
}

export default ManageUser;
